import { render, staticRenderFns } from "./TermsAndConditionsProvider.vue?vue&type=template&id=01dd3be8&scoped=true"
import script from "./TermsAndConditionsProvider.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsProvider.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionsProvider.vue?vue&type=style&index=0&id=01dd3be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dd3be8",
  null
  
)

export default component.exports